import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDatepickerModule } from '@angular/material/datepicker';

import { ComponentsModule } from '@fcom/common/components';
import { DirectiveModule } from '@fcom/common/directives';
import { PipesModule } from '@fcom/common/pipes';
import { UiComponentsModule } from '@fcom/ui-components';
import { UiTranslateModule } from '@fcom/ui-translate';

import { FileValueAccessorDirective } from '../../directives/file-value-accessor.directive';
import { DatepickerComponent } from './datepicker.component';
import { FormArrayComponent } from './form-array.component';
import { FormErrorComponent } from './form-error.component';
import { FormInputCheckboxListComponent } from './form-input-checkbox-list.component';
import { FormInputCheckboxComponent } from './form-input-checkbox.component';
import { FormInputRadioComponent } from './form-input-radio.component';
import { FormInputSelectComponent } from './form-input-select.component';
import { FormInputTextComponent } from './form-input-text.component';
import { LocationsAutocompleteComponent } from './locations-autocomplete.component';

const components = [
  DatepickerComponent,
  FormArrayComponent,
  FormErrorComponent,
  FormInputCheckboxComponent,
  FormInputCheckboxListComponent,
  FormInputRadioComponent,
  FormInputSelectComponent,
  FormInputTextComponent,
  LocationsAutocompleteComponent,
  FileValueAccessorDirective,
];

@NgModule({
  imports: [
    CommonModule,
    ComponentsModule,
    DirectiveModule,
    ReactiveFormsModule.withConfig({
      callSetDisabledState: 'whenDisabledForLegacyCode',
    }),
    MatAutocompleteModule,
    UiComponentsModule,
    UiTranslateModule,
    PipesModule,
    MatDatepickerModule,
  ],
  declarations: [...components],
  exports: [...components],
  providers: [],
})
export class CommonServiceFormsModule {}
